module.exports = __webpack_public_path__ + "static/media/KogMaw.5b9842ce.png";